/**
 * Ted #32c / epic E3.1 (#1158) — turn a `/today` arrival row into the
 * `ReservationTarget` the shared Cancel / Edit / No-show actions take. Pure,
 * so the Front Desk and the dashboard describe a row to the dialogs in the
 * same words.
 */
import type { DashboardArrival } from '../dashboard/dashboard-api.js';
import { joinDogNames } from '../dashboard/household-checkin.js';
import type { ReservationTarget } from './useReservationActions.js';

export function reservationTargetFromArrival(
  row: DashboardArrival,
  /** The facility day the row is listed under (YYYY-MM-DD). */
  day: string,
): ReservationTarget {
  const dogs = joinDogNames(row.dogNames);
  return {
    bookingId: row.bookingId,
    // Dogs first, then the owner; a row that names no dog reads as its owner.
    label: dogs ? `${dogs} — ${row.customerName}` : row.customerName,
    dogLabel: dogs || row.customerName,
    customerId: row.customerId ?? null,
    day,
  };
}
